/**
 * @file The unanswered state of an analytics answer that did not answer: an
 * absent or loading answer is loading, and a refused or failed one is refused
 * with that answer. Consumers: every model that reads a named-query answer,
 * `analyticsAnswerFigure`, `analyticsMonths`, `analyticsGroupRows`, the
 * Projects, Pipeline, Orders and Invoicing models, each of which returns it
 * before reading `result`, so no unanswered model ever reads as zero.
 */
import type { Snapshot } from 'valtio';

import type { AnalyticsAnswer, AnalyticsUnansweredFigure } from './index.types';

export const analyticsUnansweredFigure = (
  answer:
    | Snapshot<Exclude<AnalyticsAnswer, { status: 'answered' }>>
    | undefined,
): AnalyticsUnansweredFigure =>
  answer === undefined || answer.status === 'loading'
    ? { status: 'loading' }
    : { status: 'refused', answer };
